module.exports = __webpack_public_path__ + "static/img/icon_alarm_white_active1.5d55573.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_alarm_white_active1.svg
// module id = sXp6
// module chunks = 10